var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlechaReg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21656",
    "data-name": "Grupo 21656",
    transform: "translate(-8077 -2619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21655",
    "data-name": "Grupo 21655"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17278",
    "data-name": "Trazado 17278",
    d: "M3,0H17a3,3,0,0,1,3,3V21a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0Z",
    transform: "translate(8077 2619)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "proximo",
    transform: "translate(8089.41 2629) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_935",
    "data-name": "Grupo 935",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_853",
    "data-name": "Trazado 853",
    d: "M3.194,2.556.4.061a.254.254,0,0,0-.331,0,.2.2,0,0,0,0,.3L2.7,2.7.069,5.051a.2.2,0,0,0,0,.3.248.248,0,0,0,.166.062A.248.248,0,0,0,.4,5.348l2.794-2.5a.194.194,0,0,0,0-.3Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#09b3c4",
    strokeWidth: 0.5
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaReg);
export default __webpack_public_path__ + "static/media/flecha_reg.15d28f76.svg";
export { ForwardRef as ReactComponent };